'use client';

import { useState } from 'react';

import { Eye, EyeOff, Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@kit/ui/button';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '@kit/ui/input-group';

export function PasswordInput(props: React.ComponentProps<'input'>) {
  const { t } = useTranslation('auth');
  const [showPassword, setShowPassword] = useState(false);

  return (
    <InputGroup className="dark:bg-background">
      <InputGroupAddon>
        <Lock className="h-4 w-4" />
      </InputGroupAddon>

      {/* A row of asterisks reads as a password the browser already filled in,
          so the field gets a real label instead. `required` matches the schema,
          which previously only existed in Zod. */}
      {/* No default `autoComplete`: "current-password" on a sign-up form makes
          the browser offer the password being replaced, and "new-password" on
          sign-in suppresses the saved one. Every caller passes its own. */}
      <InputGroupInput
        data-test="password-input"
        required
        type={showPassword ? 'text' : 'password'}
        placeholder={t('passwordPlaceholder')}
        {...props}
      />

      <InputGroupAddon align="inline-end">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <EyeOff className="h-4 w-4" />
          ) : (
            <Eye className="h-4 w-4" />
          )}
        </Button>
      </InputGroupAddon>
    </InputGroup>
  );
}
